import {
  BuildURLListFromHierarchyList,
  BuildPathHierarchyFromPathName,
  CheckIfHomePage,
} from "./breadcrumb-list.js";

function main() {
  const scriptContainer = document.getElementById("schema-breadcrumb");
  const contentObject = BuildBreadcrumbListSchema(window.location.href);

  const contentString = JSON.stringify(contentObject);
  scriptContainer.innerText = contentString;
}

main();

function BuildBreadcrumbListSchema(href) {
  const url = new URL(href);
  const pathname = url.pathname;

  const itemListElement = [];

  if (pathname) {
    const hierarchyList = BuildPathHierarchyFromPathName(pathname, false);
    const urlList = BuildURLListFromHierarchyList(hierarchyList);

    for (let i = 0; i < urlList?.length; i++) {
      const isHomepage = CheckIfHomePage(hierarchyList[i]);
      const name = isHomepage ? "" : hierarchyList[i];

      itemListElement.push({
        "@type": "ListItem",
        position: i + 1,
        name: i == 0 ? "BreadcrumbList" : name,
        item: urlList[i],
      });
    }
  }

  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement,
  };
}
